module.exports = __webpack_public_path__ + "static/img/ml-txt2.bc459c21.png";